<template>
  <div class="index-tree-box">
    <type-tree ref="type_tree" show-action @on-select="onSelectTree" @title-click="titleClick" />
    <div class="right-box">
      <div>
        <el-switch v-model="horizontal" active-text="横排" inactive-text="竖排" :width="50"></el-switch>
      </div>
      <div style="height: calc(100vh - 200px); overflow: scroll">
        <vue2-org-tree :data="data" :horizontal="!horizontal" collapsable @on-expand="onExpand" @on-node-click="NodeClick" :render-content="renderContent" />
      </div>
      <!-- labelClassName="labelcss" -->
      <div style="display: flex; margin: 0px auto; width: 130px; justify-content: space-between">
        <el-button type="primary" @click="save" v-if="isShow">保存</el-button>
        <!-- <el-button
          type="primary"
          @click="saveAs"
          v-if="isShow"
          :disabled="!selectId"
          >另存</el-button
        > -->
        <el-button type="primary" @click="saveAsV2" v-if="isShow" :disabled="!selectId">另存</el-button>
      </div>
      <el-table border key="table1" class="table_bottom table-line tb-c-head" :data="tableData" stripe style="margin-top: 18px" ref="table1" v-if="isShow">
        <el-table-column label="存货编码" prop="ProductNo" align="center" min-width="180"> </el-table-column>
        <el-table-column label="存货名称" align="center" min-width="120" prop="ProductName">
          <template slot-scope="{ row }">
            <account-select
              v-model="row.ProductName"
              :source="DAccount"
              @select="onSelect($event, row)"
              @inputText="inputText($event, row)"
              @click.native="resetFun"
              @currentPage="currentPage($event, row)"
              :pageType="true"
              :pageSize="pageParams.pageSize"
              :pageIndex="pageParams.pageIndex"
              :listTotal="listTotal"
              isSelect
              @changeSelect="changeSelect"
            />
          </template>
        </el-table-column>
        <el-table-column label="规格型号" prop="ProductSpec" align="center" min-width="100"> </el-table-column>
        <el-table-column label="单位" prop="PdUnitId" align="center" min-width="100">
          <template slot-scope="{ row }">
            <!-- <el-select v-model="row.UnitId"  @change="setting(row)"    v-if="row.Units.length !== 0">
                <el-option v-for="item in row.Units" :key="item.UnitId" :label="item.UnitName" :value="item.UnitId" ></el-option>
            </el-select> -->
            <span>{{ row.PdUnitName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="PropertyId" label="属性" min-width="100">
          <template slot-scope="{ row }">
            <el-select filterable clearable v-model="row.PropertyId" @change="changeProperty($event, row)" v-if="row.UseProcess">
              <el-option v-for="item in propertyList" :key="item.PropertyId" :value="item.PropertyId" :label="item.PropertyName"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="颜色" prop="ColorId" align="center" min-width="100">
          <template slot-scope="{ row }">
            <el-select filterable clearable v-model="row.ColorId" @change="changeColor($event, row)" v-if="row.UseColor">
              <el-option v-for="item in row.Colors" :key="item.ColorId" :label="item.ColorName" :value="item.ColorId"></el-option>
            </el-select>
            <!-- <el-select filterable clearable v-model="row.ColorId" @change="changeColor($event, row)" v-if="row.UseColor">
              <el-option v-for="item in row.Colors" :key="item.ColorId" :label="item.ColorName" :value="item.ColorId"></el-option>
            </el-select> -->
          </template>
        </el-table-column>
        <el-table-column label="存货条码" prop="BarCode" align="center" min-width="100"> </el-table-column>
        <el-table-column label="数量" prop="Quantity" align="center" min-width="100">
          <template slot-scope="{ row, $index }">
            <el-input @input="changeQuantity($event, row, $index)" v-model="row.Quantity" placeholder="请输入数量" />
          </template>
        </el-table-column>
        <el-table-column prop="WarehouseId" label="预入仓" min-width="120">
          <template slot-scope="{ row }">
            <el-select v-model="row.WarehouseId" @change="change($event, row)">
              <el-option v-for="item in warehouseList" :key="item.WarehouseId" :label="item.WarehouseName" :value="item.WarehouseId"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="生产部门" min-width="120" prop="DpId">
          <template slot-scope="{ row }">
            <dp-select style="width: 180px" v-model="row.DpId" />
          </template>
        </el-table-column>
        <el-table-column prop="ProductionType" label="生产类型" min-width="120">
          <template slot-scope="{ row }">
            <el-select v-model="row.ProductionType">
              <el-option v-if="row.ProductNature === 2 || row.ProductNature === 0" key="ProductionType1" label="自产" :value="0"></el-option>
              <el-option v-if="row.ProductNature === 2 || row.ProductNature === 1" key="ProductionType2" label="委外" :value="1"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="ProductionDpId" label="加工商" min-width="120">
          <template slot-scope="{ row }">
            <el-select v-model="row.ProductionDpId" filterable>
              <el-option v-for="item in tradeUnitList" :key="item.TradeUnitId" :label="item.FullName" :value="item.TradeUnitId"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="图片" prop="ImgUrl" align="center" min-width="100">
          <template slot-scope="{ row }">
            <el-button type="text" @click="viewImg(row)">{{ row.ProductId ? '查看' : '' }} </el-button>
          </template>
        </el-table-column>
        <el-table-column label="加工阶段" prop="ProcessStageName" align="center" min-width="100"> </el-table-column>
        <el-table-column label="存货类型" prop="ProduceTypeName" align="center" min-width="100"> </el-table-column>
        <el-table-column label="bom版本" prop="BomNo" align="center" min-width="120">
          <template slot-scope="{ row }">
            <el-input v-model="row.BomNo" placeholder="请输入版本号" />
          </template>
        </el-table-column>
        <el-table-column label="成品率%" prop="Yieldrate" align="center" min-width="120">
          <template slot-scope="{ row }">
            <el-input v-model="row.Yieldrate" placeholder="请输入成品率" />
          </template>
        </el-table-column>

        <el-table-column label="默认BOM" prop="IsDefault" align="center" min-width="100">
          <template slot-scope="{ row }">
            <el-select v-model="row.IsDefault">
              <el-option key="IsDefault1" label="是" :value="true"></el-option>
              <el-option key="IsDefault2" label="否" :value="false"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="设计图" prop="TeImgs" align="center" min-width="100">
          <template slot-scope="{ row }">
            <el-button type="text" @click="uploadImg(row)">上传</el-button>
            <!-- <el-button v-else type="text" @click="viewImg2(row)">{{ row.TeImgs != null ? '查看' : '' }} </el-button> -->
          </template>
        </el-table-column>
      </el-table>

      <el-tabs tab-position="top" class="tabs" type="card" @tab-click="tabClick" v-if="isShow">
        <el-tab-pane>
          <div slot="label">子件</div>

          <el-table border key="table2" class="table_bottom table-line tb-c-head" :data="child" stripe style="margin-top: 18px" ref="table2" :row-class-name="tableRowClassName" @row-click="addColumn">
            <el-table-column label="子件编码" prop="ProductNo" align="center" min-width="180"> </el-table-column>
            <el-table-column label="子件名称" align="center" min-width="120" prop="ProductName">
              <template slot-scope="{ row }">
                <account-select
                  v-model="row.ProductName"
                  :source="child_DAccount"
                  @select="onSelect($event, row, 1)"
                  @inputText="inputTextChild($event, row)"
                  @click.native="resetChildFun"
                  @currentPage="currentChildPage($event, row)"
                  :pageType="true"
                  :pageSize="child_pageParams.pageSize"
                  :pageIndex="child_pageParams.pageIndex"
                  :listTotal="child_listTotal"
                  isSelect
                  @changeSelect="changeSelectChild"
                />
              </template> </el-table-column
            ><el-table-column label="子件Bom" prop="ChildBomNo" align="center" min-width="120">
              <template slot-scope="{ row }">
                <!-- <span  >{{row.BomNo}}</span> -->
                <child-select v-show="!row.isSelectMould && row.isSelectChild" v-model="row.ChildBomNo" :source="row.child_arrList" @select="onSelectChild($event, row)" :pageType="false" />
              </template>
            </el-table-column>
            <el-table-column label="注塑bom版本号" prop="MouldBomNo" align="center" min-width="120">
              <template slot-scope="{ row }">
                <!-- <span  >{{row.BomNo}}</span> -->
                <child-select
                  v-show="row.isSelectMould"
                  v-model="row.MouldBomNo"
                  :source="row.MouldBomNos"
                  :Head="[
                    { Value: 'MouldNo', Name: '模具编码', Width: '150' },
                    { Value: 'MouldName', Name: '模具名称', Width: '120' },
                    { Value: 'Bomno', Name: '版本号', Width: '120' }
                  ]"
                  @select="onSelectMouldBomNo($event, row)"
                  :pageType="false"
                />
              </template>
            </el-table-column>
            <el-table-column label="规格型号" prop="ProductSpec" align="center" min-width="100"> </el-table-column>
            <el-table-column label="单位" prop="PdUnitId" align="center" min-width="100">
              <template slot-scope="{ row }">
                <!-- <el-select v-model="row.UnitId"  v-if="row.Units.length !== 0">
                  <el-option v-for="item in row.Units" :key="item.UnitId" :label="item.UnitName" :value="item.UnitId" ></el-option>
              </el-select> -->
                <span>{{ row.PdUnitName }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="PropertyId" label="属性" min-width="100">
              <template slot-scope="{ row }">
                <el-select filterable clearable v-model="row.PropertyId" @change="changeP($event, row)" v-if="row.UseProcess && !row.ChildBomNo && !row.MouldBomNo && row.isSelectChild">
                  <el-option v-for="item in propertyList" :key="item.PropertyId" :value="item.PropertyId" :label="item.PropertyName"></el-option>
                </el-select>
                <span v-else>{{ row.PropertyName }}</span>
              </template>
            </el-table-column>
            <el-table-column label="颜色" prop="ColorId" align="center" min-width="100">
              <template slot-scope="{ row }">
                <el-select filterable clearable v-model="row.ColorId" @change="changeColor($event, row)" v-if="row.UseColor && !row.ChildBomNo && !row.MouldBomNo && row.isSelectChild">
                  <el-option v-for="item in row.Colors" :key="item.ColorId" :label="item.ColorName" :value="item.ColorId"></el-option>
                </el-select>
                <!-- <el-select filterable clearable v-model="row.ColorId" @change="changeColor($event, row)" v-if="row.UseColor && !row.ChildBomNo && !row.MouldBomNo && row.isSelectChild">
                  <el-option v-for="item in row.Colors" :key="item.ColorId" :label="item.ColorName" :value="item.ColorId"></el-option>
                </el-select> -->
                <span v-else>{{ row.ColorName }}</span>
              </template>
            </el-table-column>
            <el-table-column label="存货条码" prop="BarCode" align="center" min-width="100"> </el-table-column>
            <el-table-column label="数量" prop="Quantity" align="center" min-width="100">
              <template slot-scope="{ row, $index }">
                <el-input v-model="row.Quantity" @input="changeQuantity($event, row, $index)" placeholder="请输入数量" />
              </template>
            </el-table-column>
            <el-table-column prop="WarehouseId" label="预出仓" min-width="120">
              <template slot-scope="{ row, $index }">
                <el-select v-model="row.WarehouseId" @change="changeOutWarehouse($event, row, $index)">
                  <el-option v-for="item in warehouseList" :key="item.WarehouseId" :label="item.WarehouseName" :value="item.WarehouseId"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="产品图片" prop="ImgUrl" align="center" min-width="100">
              <template slot-scope="{ row }">
                <el-button type="text" @click="viewImg(row)">{{ row.ProductId ? '查看' : '' }} </el-button>
              </template>
            </el-table-column>
            <el-table-column label="加工阶段" prop="ProcessStageName" align="center" min-width="100"> </el-table-column>
            <el-table-column label="存货类型" prop="ProduceTypeName" align="center" min-width="100"> </el-table-column>

            <el-table-column label="损耗率" prop="Loss" align="center" min-width="100">
              <template slot-scope="{ row }">
                <span>{{ row.Loss }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="操作">
              <template slot-scope="{ row, $index }">
                <el-button type="text" @click.stop="delTableList(row, $index)">删除 </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane>
          <div slot="label">工序</div>
          <div v-for="(item, index) in craftData" :key="index">
            <div class="flex1">
              <div class="flex2">
                <el-input placeholder="自定义方案名称" @change="changeProgrammeName" v-model="item.ProgrammeName" />
                <el-button type="primary" @click="changeProgramme(item)">选择方案</el-button>
              </div>
              <div class="flex2">
                <el-button v-show="isSaveProgramme" type="primary" @click="saveProgramme">保存</el-button>
                <el-button type="primary" @click="addProcesses">添加工序</el-button>
              </div>
            </div>

            <el-table :data="item.Processes" class="table_bottom table-line tb-c-head" border ref="list3">
              <el-table-column prop="ProcessId" label="工序名称" min-width="120">
                <template slot-scope="{ row }">
                  <el-select v-model="row.ProcessId" @change="changeProcesses">
                    <el-option v-for="(item, index) in teProcessList" :key="index" :value="item.ProcessId" :label="item.ProcessName"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="ProductionType" label="自制工序或者委外工序" min-width="120">
                <template slot-scope="{ row }">
                  <el-select v-model="row.ProcessType" @change="changeProcessType($event, row)">
                    <el-option key="a1" label="自制工序" :value="0"></el-option>
                    <el-option key="a2" label="委外工序" :value="1"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="TradeUnitId" label="委外供应商" min-width="120">
                <template slot-scope="{ row }">
                  <div class="flex" v-show="row.ProcessType === 1">
                    <el-input type="text" v-model="row.TradeUnitName" readonly />
                    <el-button type="primary" @click="selectCome(row)">选择</el-button>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="操作" fixed="right" align="center" width="80">
                <template slot-scope="{ row, $index }">
                  <el-button type="text" @click="delProcesses(row, $index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-tab-pane>
      </el-tabs>

      <list-dialog2 ref="listDialog2" selectable :multiple="false" @select="listDialogSelect"></list-dialog2>
      <list-dialog3 ref="listDialog3" selectable :multiple="false" @select="listDialogSelect"></list-dialog3>
      <list-dialog4 ref="listDialog4" selectable :multiple="false" @select="listDialogSelect"></list-dialog4>

      <process-dialog ref="processDialog" @saved="detail_saved"></process-dialog>

      <!-- <edit-dialog ref="editDialog"></edit-dialog> -->
      <img-dialog ref="imgDialog" :imgs="imgs" />
      <come-list-dialog @select="comeSelect" selectable :multiple="false" ref="comeListDialog" in-dialog />
      <bom-dialog ref="bomDialog" @confirm="toSaveAs"></bom-dialog>
      <bom-img-dialog ref="bomImgDialog" @saved="img_saved" />
    </div>
  </div>
</template>
<script>
import Vue2OrgTree from 'vue2-org-tree'
import 'vue2-org-tree/dist/style.css'
import imgDialog from '@/components/production/craftsmanship/bom/imgDialog'
import childSelect from '@/components/business/stock/childSelect'
import accountSelect from '@/components/business/stock/select'
import processDialog from '@/components/production/craftsmanship/combinationbom/processDialog'
import listDialog4 from '@/components/production/craftsmanship/solutions/assemble/listDialog' // 组合
import listDialog3 from '@/components/production/craftsmanship/solutions/assembly/listDialog' // 装配
import listDialog2 from '@/components/production/craftsmanship/solutions/fittings/listDialog' // 配件

import comeListDialog from '@/components/basedata/business/come/listDialog'

import typeTree from './tree'
import bomDialog from '@/views/production/craftsmanship/bom/bomDialog'
import dpSelect from '@/components/production/clothmanagement/cloth/workorder/dpSelect'
import bomImgDialog from '@/components/production/craftsmanship/bom/bomImgDialog'

export default {
  components: {
    Vue2OrgTree,
    imgDialog,
    listDialog4,
    listDialog3,
    listDialog2,
    processDialog,
    accountSelect,
    childSelect,
    typeTree,
    comeListDialog,
    bomDialog,
    dpSelect,
    bomImgDialog
  },
  data() {
    return {
      classList: [],
      api: require('@/api/production/teProduct').default,
      classApi: require('@/api/ba/class').default,
      colorApi: require('@/api/ba/color').default,
      warehouseApi: require('@/api/ba/warehouse').default,
      businessTypeApi: require('@/api/ba/businessType').default,
      tradeUnitApi: require('@/api/ba/tradeUnit').default,
      code_api: require('@/api/sy/serialCode').default,
      pdApi: require('@/api/ba/product').default,
      propertyApi: require('@/api/ba/property').default,
      teProgrammeApi: require('@/api/production/teProgramme').default,
      teProcessApi: require('@/api/production/teProcess').default,
      teProcessList: [],
      teMouldBomApi: require('@/api/production/teMouldBom').default,
      warehouseList: [],
      treedata: {
        id: 0,
        label: 'XXX科技有限公司',
        expand: true,
        children: [
          {
            id: 2,
            label: '产品研发部',
            expand: true,
            children: [
              {
                id: 5,
                label: '研发-前端',
                expand: true
              },
              {
                id: 6,
                label: '研发-后端',
                expand: true
              },
              {
                id: 9,
                label: 'UI设计',
                expand: true
              },
              {
                id: 10,
                label: '产品经理',
                expand: true
              }
            ]
          },
          {
            id: 3,
            label: '销售部',
            expand: true,
            children: [
              {
                id: 7,
                label: '销售一部',
                expand: true
              },
              {
                id: 8,
                label: '销售二部',
                expand: true
              }
            ]
          },
          {
            id: 4,
            label: '财务部',
            expand: true
          },
          {
            id: 9,
            label: 'HR人事',
            expand: true
          }
        ]
      },
      currentRow: null,
      data: {
        children: [],
        TeProductId: 0,
        ProductId: 0,
        Bomno: '',
        ColorId: null,
        Quantity: null,
        IsDefault: true,
        Sn: 0,
        ProductName: '',
        ShortName: '',
        ProductNo: '',
        SaUnitId: 0,
        PuUnitId: 0,
        SkUnitId: 0,
        PdUnitId: 0,
        RpUnitId: 0,
        SaUnitName: '',
        PuUnitName: '',
        SkUnitName: '',
        PdUnitName: '',
        RpUnitName: '',
        ColorName: '',
        ProductSpec: '',
        Status: 0,
        ProductType: 0,
        ProduceTypeName: '',
        ProcessStage: 0,
        ProcessStageName: '',
        PropertyId: null,
        Quantity2: 0,
        Yieldrate: '',
        UnitId: 0,
        PdUnitId: 0,
        PdUnitName: '',
        UnitId2: 0,
        Rate: 0,
        Disabled: 0,
        WarehouseId: 0,
        RationManHour: 0,
        RationWage: 0,
        RationCharge: 0,
        AddTime: '',
        MakeEmpId: 0,
        MakeDate: '',
        ReviewEmpId: 0,
        ReviewDate: '',
        UpdateEmpId: 0,
        UpdateDate: '',
        IsSale: true,
        IsPurchase: true,
        IsMachining: true,
        IsExpend: true,
        IsLabourService: true,
        PropertyName: '',
        WarehouseNo: '',
        WarehouseName: '',
        UnitName: '',
        UnitName2: '',
        MakeEmpName: '',
        ReviewEmpName: '',
        UpdateEmpName: '',
        ImgUrl: '',
        ProductNature: 0
      },
      horizontal: false,
      isShow: false,
      initDAccount: [],
      initTotal: 0,
      DAccount: [],
      deleteList: [],
      listTotal: 0,
      child_initDAccount: [],
      child_initTotal: 0,
      child_DAccount: [],
      child_listTotal: 0,
      imgs: [],
      child_arrList: [],
      pageParams: {
        pageSize: 7, //分页大小
        pageIndex: 1
      },
      child_pageParams: {
        pageSize: 7, //分页大小
        pageIndex: 1
      },
      craftData: [
        {
          ProgrammeName: '',
          ProgrammeId: 0,
          Processes: []
        }
      ],
      deleteCraftData: [],
      child: [
        {
          ProductId: 0,
          ProductNo: '',
          ProductName: '',
          ProductSpec: '',
          UnitId: 0,
          UnitName: '',
          PdUnitId: 0,
          PdUnitName: '',
          Quantity: null,
          ImgUrl: '',
          ProcessStage: '',
          ProcessStageName: '',
          ProduceTypeName: '',
          ChildBomNo: '',
          MouldBomNo: '',
          MouldBomNos: [],
          isSelectMouldBomno: false,
          isSelectMould: false,
          Units: [],
          UseColor: true,
          ColorId: null,
          ColorName: '',
          Colors: [],
          Loss: 0,
          LossRate: 0,
          PropertyId: null,
          child_arrList: [],
          WarehouseId: null
        }
      ],
      currentStage: 0,
      tableData: [
        {
          ProductId: 0,
          ProductNo: '',
          ProductName: '',
          ProductSpec: '',
          UnitId: 0,
          UnitName: '',
          PdUnitId: 0,
          PdUnitName: '',
          Quantity: null,
          ImgUrl: '',
          ProcessStage: '',
          ProcessStageName: '',
          ProduceTypeName: '',
          BomNo: '',
          ProductionType: null,
          ProductNature: null,
          ProductionDpNo: '',
          ProductionDpId: null,
          IsDefault: false,
          Units: [],
          UseColor: true,
          ColorId: 0,
          ColorName: '',
          Yieldrate: 100,
          PropertyId: 0,
          PropertyName: '',
          DpId: '',
          TeImgs: []
        }
      ],
      propertyList: [],
      isSaveProgramme: false, //方案保存
      copyCraftData: [], // 工艺方案拷贝
      currentClassId: null,
      currentClassChildId: null,
      pickId: 0,
      pId: 0,
      selectId: null,
      colorList: [],
      options: []
    }
  },
  mounted() {
    this.$refs.type_tree.getData()
  },
  created() {
    this.teProcessApi.list({}).then(res => {
      if (res.Code === 0) {
        this.teProcessList = res.Data

        // console.log("====this.teProcessList ====", this.teProcessList);
      }
    })
    this.warehouseApi.list({}).then(res => {
      if (res.Code === 0) {
        this.warehouseList = res.Data
      }
    })
    this.tradeUnitApi.list({ TradeUnitTypes: [3], Status: 1 }).then(res => {
      if (res.Code === 0) {
        this.tradeUnitList = res.Data
      }
    })
  },
  methods: {
    filterSelectMethod(key) {
      console.log(key)
      if (key) {
        this.options = this.colorList.filter(item => item.ColorNo.includes(key) || item.ColorName.includes(key))
      } else {
        this.options = this.colorList
      }
    },
    changeProperty(val, row) {
      console.log(val, row, 'changeProperty')
      this.setting(row)
      row.PropertyNo = ''
      if (val) {
        var property = this.propertyList.find(x => x.PropertyId == val)
        if (property) {
          row.PropertyNo = property.PropertyNo
        }
      }

      if (row.ProductId > 0) {
        row.BarCode = row.ProductNo + '*' + (row.ColorNo || 0) + '*' + (row.PropertyNo || 0) + '*' + (row.TrademarkNo || 0)
      }
    },
    changeColor(val, row) {
      console.log(val, row, 'changeColor')
      this.setting(row)
      row.ColorNo = ''
      if (val) {
        var color = this.colorList.find(x => x.ColorId == val)
        if (color) {
          row.ColorNo = color.ColorNo
        }
      }
      if (row.ProductId > 0) {
        row.BarCode = row.ProductNo + '*' + (row.ColorNo || 0) + '*' + (row.PropertyNo || 0) + '*' + (row.TrademarkNo || 0)
      }
      this.options=this.colorList;
    },
    img_saved(data, removeData) {
      console.log(data, removeData, 'img_saved')
      if (data) {
        console.log(data, removeData, 'img_saved2')
        var imgs = []
        data.forEach(item => {
          imgs.push({ TeProductId: this.data.TeProductId, ImgUrl: item.url2, T: item.T, ProductImgId: item.ProductImgId })
        })
        if (removeData.length > 0) {
          removeData.forEach(item => {
            imgs.push({ TeProductId: this.data.TeProductId, ImgUrl: item.url2, T: 2, ProductImgId: item.ProductImgId })
          })
        }
        this.teImgs = imgs
        this.selectRow.TeImgs = imgs
      }
    },
    uploadImg(row) {
      console.log(row, 'row')
      this.selectRow = row
      if (this.data.TeProductId > 0) {
        this.$refs.bomImgDialog.openEdit(row)
      } else {
        if (this.teImgs) {
          row.TeImgs = this.teImgs
        }
        this.$refs.bomImgDialog.openCreate(row)
      }
    },
    changeOutWarehouse(val, row, index) {
      // console.log("val",val,"row",row)
      if (row.T !== 0) {
        row.T = 1
      }
      var obj = { ...row }
      this.child.splice(index, 1, obj)
      //this.$forceUpdate()
    },
    changeProcessType(val, row) {
      if (row.T !== 0) {
        row.T = 1
      }
    },
    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex
    },
    renderContent(h, data) {
      var classname = 'labelcss'
      if (data) {
        if (data.lvl > 0) {
          var lvl = data.lvl % 5
          classname = 'labelcss labelcss' + lvl
        }

        if (data.PropertyName) {
          if (data.ColorName) {
            return (
              <span style="display:block; text-align: left;" class={classname}>
                <span title={data.label} style="display:block">
                  {data.label}
                </span>
                <span title={data.BarCode} style="display:block">
                  {data.BarCode}
                </span>
                <span title={data.ColorName}>颜色：{data.ColorName}，</span>
                <span title={data.PropertyName}>属性：{data.PropertyName}，</span>
                <span title={data.Quantity}>数量：{data.Quantity}</span>
              </span>
            )
          } else {
            return (
              <span style="display:block; text-align: left;" class={classname}>
                <span title={data.label} style="display:block">
                  {data.label}
                </span>
                <span title={data.BarCode} style="display:block">
                  {data.BarCode}
                </span>
                <span title={data.PropertyName}>属性：{data.PropertyName}，</span>
                <span title={data.Quantity}>数量：{data.Quantity}</span>
              </span>
            )
          }
        } else {
          if (data.Quantity) {
            if (data.ColorName) {
              return (
                <span style="display:block; text-align: left;" class={classname}>
                  <span title={data.label} style="display:block">
                    {data.label}
                  </span>
                  <span title={data.BarCode} style="display:block">
                    {data.BarCode}
                  </span>
                  <span title={data.ColorName}>颜色：{data.ColorName}，</span>
                  <span title={data.Quantity}>数量：{data.Quantity}</span>
                </span>
              )
            } else {
              return (
                <span style="display:block; text-align: left;" class={classname}>
                  <span title={data.label} style="display:block">
                    {data.label}
                  </span>
                  <span title={data.BarCode} style="display:block">
                    {data.BarCode}
                  </span>
                  <span title={data.Quantity} style="display:block">
                    数量：{data.Quantity}
                  </span>
                </span>
              )
            }
          } else {
            return (
              <span style="display:block; text-align: left;" class={classname}>
                <span style="display:block">新增</span>
              </span>
            )
          }
        }
      }
    },
    onSelectTree(data) {
      console.log('onSelect', data)
      this.selectId = data.TeProductId
      this.loadInfo(data.TeProductId)
      this.isShow = false
      // this.reload();
    },
    titleClick() {
      this.selectId = null
      this.isShow = false
      this.data = {}
      this.tableData = [
        {
          ProductId: 0,
          ProductNo: '',
          ProductName: '',
          ProductSpec: '',
          UnitId: 0,
          UnitName: '',
          PdUnitId: 0,
          PdUnitName: '',
          Quantity: null,
          ImgUrl: '',
          ProcessStage: '',
          ProcessStageName: '',
          ProduceTypeName: '',
          BomNo: '',
          ProductionType: null,
          ProductNature: null,
          ProductionDpNo: '',
          ProductionDpId: 0,
          IsDefault: false,
          Units: [],
          UseColor: true,
          ColorId: null,
          ColorName: '',
          UseProcess: false,
          Yieldrate: 100,
          PropertyId: null,
          PropertyName: '',
          Colors: [],
          TeImgs: []
        }
      ]
      this.child = [
        {
          ProductId: 0,
          ProductNo: '',
          ProductName: '',
          ProductSpec: '',
          UnitId: 0,
          UnitName: '',
          PdUnitId: 0,
          PdUnitName: '',
          Quantity: null,
          ImgUrl: '',
          ProcessStage: '',
          ProcessStageName: '',
          ProduceTypeName: '',
          ChildBomNo: '',
          MouldBomNo: '',
          MouldBomNos: [],
          isSelectMouldBomno: false,
          isSelectMould: false,
          Units: [],
          UseColor: true,
          ColorId: null,
          ColorName: '',
          Colors: [],
          Loss: 0,
          LossRate: 0,
          PropertyId: null,
          PropertyName: '',
          child_arrList: []
        }
      ]
    },

    loadInfo(id) {
      //var id = 208;
      this.api.getTreeInfo(id).then(res => {
        this.data = { ...res.Data }
        console.log('this.data', this.data)
      })
    },
    collapse(list) {
      var _this = this
      list.forEach(child => {
        child.expand = !child.expand
        child.children && _this.collapse(child.children)
      })
    },
    // 点击折叠
    onExpand(e, data) {
      data.expand = !data.expand
      if (!data.expand && data.children) {
        this.collapse(data.children)
      }
    },
    //点击事件
    NodeClick(e, data) {
      console.log('触发NodeClick', data, e)
      this.pickId = data.TeProductId
      this.pId = data.TeProductDetailId || 0

      var node_list = document.getElementsByClassName('labelcss')
      // console.log('node_list',node_list);
      for (let i = 0; i < node_list.length; i++) {
        node_list[i].classList.remove('node-select')
      }
      var parent = e.target.parentElement
      parent.classList.add('node-select')
      //获取子件bom 信息
      if (data.ChildTeProductId > 0) {
        this.editOrder(data.ChildTeProductId)
      }
      //不存在下级bom不操作
      else if (data.TeProductDetailId > 0) {
        this.isShow = false
        if (data.IsMachining) {
          // console.log("add", data);
          this.addOrder(data)
        }
      } //获取根bom信息
      else {
        // console.log("点击", e, data);
        this.editOrder(data.TeProductId)
      }
    },
    selectCome(row) {
      this.currentRow = row
      this.$refs.comeListDialog.open().then(that => {
        that.getData({ TradeUnitType: 3 })
      })
    },
    comeSelect(row) {
      this.currentRow.DpId = row.TradeUnitId
      this.currentRow.TradeUnitName = row.FullName
      if (this.currentRow.T !== 0) {
        this.currentRow.T = 1
      }

      // console.log('craftData', this.craftData)
    },
    changeP(e, row) {
      if (row.T == null) {
        row.T = 1
      }
      row.PropertyNo = ''
      if (e) {
        var property = this.propertyList.find(x => x.PropertyId == e)
        if (property) {
          row.PropertyNo = property.PropertyNo
        }
      }
      if (row.ProductId > 0) {
        row.BarCode = row.ProductNo + '*' + (row.ColorNo || 0) + '*' + (row.PropertyNo || 0)
      }

      // if (e === 1 && row.MouldId != null && row.ProductType === 2) {
      //   row.isSelectMouldBomno = true
      //   row.isSelectMould = true
      // } else {
      //   row.isSelectMouldBomno = false
      //   row.isSelectMould = false
      // }
    },
    setting(row) {
      if (row.T == null) row.T = 1
    },
    changeSelectChild(val) {
      this.currentClassChildId = val

      if (val == null) {
        return
      }
      if (val.indexOf('.')) {
        var str = val.split('.')
        this.currentClassChildId = str[str.length - 1]
      }
      this.pdApi
        .list({
          IdChain: this.currentClassChildId,
          Status: 1,
          pageSize: this.pageParams.pageSize,
          pageIndex: this.pageParams.pageIndex
        })
        .then(res => {
          if (res.Code == 0) {
            this.child_DAccount = res.Data
            this.child_listTotal = res.Count
          }
        })
    },
    changeSelect(val) {
      this.currentClassId = val

      if (val == null) {
        return
      }
      if (val.indexOf('.')) {
        var str = val.split('.')
        this.currentClassId = str[str.length - 1]
      }
      this.pdApi
        .list({
          ClassId: this.currentClassId,
          Status: 1,
          pageSize: this.pageParams.pageSize,
          pageIndex: this.pageParams.pageIndex
        })
        .then(res => {
          if (res.Code == 0) {
            this.DAccount = res.Data
            this.listTotal = res.Count
          }
        })
    },
    addOrder(data) {
      this.init()
      this.isShow = true
      this.tableData[0].TeProductId = 0
      this.tableData[0].BomNo = ''
      this.tableData[0].ProductId = data.ProductId
      this.tableData[0].ProductNo = data.ProductNo
      this.tableData[0].ProductSpec = data.ProductSpec
      this.tableData[0].UnitId = data.UnitId != null ? data.UnitId : 0
      this.tableData[0].UnitName = data.UnitName
      this.tableData[0].PdUnitId = data.PdUnitId != null ? data.PdUnitId : 0
      this.tableData[0].PdUnitName = data.PdUnitName
      this.tableData[0].ImgUrl = data.ImgUrl
      this.tableData[0].Imgs = data.Imgs
      this.tableData[0].TeImgs = data.TeImgs
      this.tableData[0].Yieldrate = 1 * 100
      //Quantity
      this.tableData[0].Quantity = 1
      this.tableData[0].ProcessStage = data.ProcessStage
      this.tableData[0].ProcessStageName = data.ProcessStageName
      this.tableData[0].ProductName = data.ProductName
      this.tableData[0].ProductionDpNo = data.ProductionDpNo
      this.tableData[0].ProductionType = data.ProductionType
      this.tableData[0].ProductNature = data.ProductNature
      this.tableData[0].IsDefault = false
      this.tableData[0].ProductionDpId = data.ProductionDpId
      this.tableData[0].ProduceTypeName = data.ProduceTypeName
      this.tableData[0].TeProductDetailId = data.TeProductDetailId
      this.tableData[0].Colors = data.Colors
      this.tableData[0].UseColor = data.UseColor
      this.tableData[0].ColorId = data.ColorId
      this.tableData[0].ColorName = data.ColorName
      this.tableData[0].UseProcess = data.UseProcess
      this.tableData[0].PropertyId = data.PropertyId
      this.tableData[0].PropertyName = data.PropertyName
      this.tableData[0].DpId = data.DpId

      this.currentStage = data.ProcessStage

      if (this.currentStage === 2 || this.currentStage === 3 || this.currentStage === 4) {
        this.teProgrammeApi
          .list({
            ProgrammeType: this.currentStage - 1,
            ProductName: data.ProductName,
            IsDefault: true
          })
          .then(res => {
            if (res.Code === 0 && res.Data.length > 0) {
              let { ProgrammeId, ProgrammeName, Processes } = res.Data[0]
              let o = {
                ProgrammeName,
                ProgrammeId,
                Processes
              }

              let arr = []
              arr.push(o)
              this.craftData = arr

              console.log('this.craftData', this.craftData)
            } else {
              this.craftData = [
                {
                  ProgrammeName: '',
                  ProgrammeId: 0,
                  Processes: []
                }
              ]
            }
          })
      }

      if (this.currentStage === 1 || this.currentStage === 0) {
        this.craftData = []
      }
    },
    async saveProgramme() {
      // 方案保存
      // 获取加工阶段，设置工艺方案类型
      let { ProcessStage, ProductId } = this.tableData[0]
      let programmeType = null
      console.log('ProcessStage', ProcessStage)
      if (ProcessStage === 4) {
        programmeType = ProcessStage - 1
      } else if (ProcessStage === 3) {
        programmeType = ProcessStage - 1
      } else if (ProcessStage === 2) {
        programmeType = ProcessStage - 1
      }
      console.log('programmeType', programmeType)
      if (programmeType != null) {
        let sn = await this.teProgrammeApi.getMaxSn(programmeType)
        console.log('sn', sn)
        let Products = []
        let o = {
          T: 0,
          ProgrammeProductId: 0,
          ProductId: ProductId,
          ProgrammeId: this.craftData[0].ProgrammeId,
          ProgrammeName: this.craftData[0].ProgrammeName,
          ProgrammeType: programmeType,
          SchedulingType: 0
        }
        Products.push(o)

        let Processes = []
        this.craftData[0].Processes.forEach(item => {
          let o1 = {
            T: 0,
            ProgrammeProcessId: 0,
            ProgrammeId: 0,
            ProcessId: item.ProcessId,
            ProgrammeName: this.craftData[0].ProgrammeName,
            ProgrammeType: programmeType,
            SchedulingType: 0
          }

          Processes.push(o1)
        })

        let obj = {
          Processes,
          Products,
          ProgrammeId: 0,
          ProgrammeName: this.craftData[0].ProgrammeName,
          ProgrammeType: programmeType,
          ProductType: 1,
          SchedulingType: 0,
          Sn: sn,
          IsDefault: true
        }

        var loading = this.$loading({
          lock: true,
          text: '正在保存...',
          spinner: 'el-icon-loading',
          customClass: 'my_loading',
          background: 'rgba(0, 0, 0, 0.3)'
        })
        console.log('obj', obj)

        try {
          let res = await this.teProgrammeApi.save(obj)
          console.log('res', res)
          let ProgrammeId = res.Data
          this.craftData[0].ProgrammeId = ProgrammeId
          this.craftData[0].Processes.forEach(item => {
            item.ProgrammeId = ProgrammeId
          })
          this.$message.success(res.Msg)
          this.isSaveProgramme = false
        } catch (err) {
          console.error(err)
          this.$message.error(res.Msg)
        } finally {
          loading.close()
        }
      }
    },
    changeProgrammeName(val) {
      console.log('val', val)
      this.craftData[0].ProgrammeId = 0
      this.isSaveProgramme = true
      this.craftData[0].Processes.forEach(item => {
        item.ProgrammeId = 0
        item.ProgrammeName = val
      })
      if (this.copyCraftData.length > 0) {
        this.copyCraftData[0]?.Processes.forEach(item => {
          item.T = 2
        })
        this.deleteCraftData = this.copyCraftData
      }
    },
    changeProcesses() {
      if (this.craftData[0].ProgrammeId !== 0) {
        this.$message.error('请先修改方案名称')
        this.isSaveProgramme = true
        return
      }
    },
    delProcesses(row, index) {
      if (this.craftData[0].ProgrammeId !== 0) {
        this.$message.error('请先修改方案名称')
        return
      }

      this.craftData[0].Processes.splice(index, 1)
    },
    addProcesses() {
      console.log('this.craftData', this.craftData)
      if (this.craftData[0].ProgrammeId !== 0) {
        this.$message.error('请先修改方案名称')
        return
      }

      let o = {
        BomType: 0,
        TradeUnitId: 0,
        ProcessId: null,
        ProcessName: '',
        ProcessType: null,
        ProgrammeId: 0,
        ProgrammeName: this.craftData[0].ProgrammeName,
        T: 0,
        TeProductId: 0,
        TeProductProcessId: 0,
        TebomId: 0,
        TespecialBomId: 0,
        TradeUnitName: null
      }
      this.craftData[0].Processes.push(o)
    },
    editOrder(data) {
      console.log('editOrder===', data)

      this.init()
      this.isShow = true
      if (data > 0) {
        this.api.getNewInfo(data).then(res => {
          if (res.Code === 0) {
            this.Status = res.Data.Status
            this.MakeEmpName = res.Data.MakeEmpName
            this.ReviewEmpName = res.Data.ReviewEmpName
            this.tableData[0].TeProductId = res.Data.TeProductId
            this.tableData[0].BomNo = res.Data.Bomno
            this.tableData[0].ProductId = res.Data.ProductId
            this.tableData[0].ProductNo = res.Data.ProductNo
            this.tableData[0].ProductSpec = res.Data.ProductSpec
            this.tableData[0].UnitId = res.Data.UnitId != null ? res.Data.UnitId : 0
            this.tableData[0].UnitName = res.Data.UnitName
            this.tableData[0].PdUnitId = res.Data.PdUnitId != null ? res.Data.PdUnitId : 0
            this.tableData[0].PdUnitName = res.Data.PdUnitName
            this.tableData[0].ImgUrl = res.Data.ImgUrl
            this.tableData[0].Imgs = res.Data.Imgs
            this.tableData[0].TeImgs = res.Data.TeImgs
            this.tableData[0].Yieldrate = res.Data.Yieldrate * 100
            //Quantity
            this.tableData[0].Quantity = res.Data.Quantity
            this.tableData[0].ProcessStage = res.Data.ProcessStage
            this.tableData[0].ProcessStageName = data.ProcessStageName
            this.tableData[0].ProductName = res.Data.ProductName
            this.tableData[0].ProductionDpNo = res.Data.ProductionDpNo
            this.tableData[0].ProductionType = res.Data.ProductionType
            this.tableData[0].ProductNature = res.Data.ProductNature
            this.tableData[0].IsDefault = res.Data.IsDefault
            this.tableData[0].ProductionDpId = res.Data.ProductionDpId
            this.tableData[0].ProduceTypeName = res.Data.ProduceTypeName
            this.tableData[0].Colors = res.Data.Colors
            this.tableData[0].UseColor = res.Data.UseColor
            this.tableData[0].ColorId = res.Data.ColorId || null
            this.tableData[0].ColorName = res.Data.ColorName
            this.tableData[0].UseProcess = res.Data.UseProcess
            this.tableData[0].PropertyId = res.Data.PropertyId || null
            this.tableData[0].PropertyName = res.Data.PropertyName
            this.tableData[0].WarehouseId = res.Data.WarehouseId || null
            this.tableData[0].WarehouseName = res.Data.WarehouseName
            this.tableData[0].DpId = res.Data.DpId
            this.tableData[0].ColorNo = res.Data.ColorNo
            this.tableData[0].PropertyNo = res.Data.PropertyNo
            this.tableData[0].TrademarkNo = res.Data.TrademarkNo
            if (res.Data.BarCode) {
              this.tableData[0].BarCode = res.Data.BarCode
            } else {
              this.tableData[0].BarCode = res.Data.ProductNo + '*' + (res.Data.ColorNo || '0') + '*' + (res.Data.PropertyNo || '0') + '*' + (res.Data.TrademarkNo || '0')
            }
            this.currentStage = res.Data.ProcessStage
            let arr = []
            res.Data.DetailModels.forEach(item => {
              item.T = null
              let isSelectMould = false
              let isSelectChild = true
              let barcode = item.BarCode
              if (item.ProcessStageName === '注塑' && item.ProduceTypeName === '胶件') {
                isSelectMould = true
              }
              if (item.IsPurchase == true && item.IsSale == false && item.IsMachining == false && item.IsExpend == false && item.IsLabourService == false) {
                isSelectChild = false
                barcode = ''
              }
              let o = {
                ProgrammeName: item.ProgrammeName,
                ProcessSn: item.Sn == null ? item.ProcessSn : item.Sn,
                MouldBomNos: [],
                child_arrList: [],
                isSelectChild: isSelectChild,
                isSelectMould: isSelectMould,
                isSelectMouldBomno: false,
                ...item,
                Units: item.Units == null ? '' : item.Units,
                Colors: item.Colors == null ? '' : item.Colors,
                PropertyId: item.PropertyId || null,
                ColorId: item.ColorId || null,
                BarCode: barcode
              }
              arr.push(o)
            })
            this.child = arr
            if (this.child.length == 0) {
              this.addList()
            }
            this.child.forEach(item => {
              this.api
                .list({
                  ProductId: item.ProductId,
                  pageIndex: 1,
                  pageSize: 7,
                  Disabled: 0
                })
                .then(res => {
                  if (res.Code == 0) {
                    item.child_arrList = res.Data

                    console.log('item.child_arrList', item.child_arrList)
                  }
                })

              if (item.MouldId) {
                this.teMouldBomApi
                  .bomList({
                    IsEnable: true,
                    MouldId: item.MouldId
                  })
                  .then(res => {
                    if (res.Code === 0) {
                      item.MouldBomNos = res.Data
                    }
                  })
              }
            })

            let ProcessModels = res.Data.ProcessModels
            console.log('ProcessModels', ProcessModels)
            if (ProcessModels != null && ProcessModels.length > 0) {
              if (this.currentStage === 1 || this.currentStage === 0) {
                this.craftData = []
              } else {
                let arr = []
                ProcessModels.forEach(item => {
                  item.T = 1
                })
                let o = {
                  ProgrammeName: ProcessModels[0].ProgrammeName,
                  ProgrammeId: ProcessModels[0].ProgrammeId,
                  Processes: ProcessModels
                }
                arr.push(o)
                this.craftData = arr //ProcessModel

                this.copyCraftData = JSON.parse(JSON.stringify(this.craftData))
              }
            } else {
              if (this.currentStage === 2 || this.currentStage === 3 || this.currentStage === 4) {
                this.teProgrammeApi
                  .list({
                    ProgrammeType: this.currentStage - 1,
                    ProductName: res.Data.ProductName,
                    IsDefault: true
                  })
                  .then(res1 => {
                    if (res1.Code === 0 && res1.Data.length > 0) {
                      let { ProgrammeId, ProgrammeName, Processes } = res1.Data[0]

                      let o = {
                        ProgrammeName,
                        ProgrammeId,
                        Processes
                      }

                      let arr = []
                      arr.push(o)
                      this.craftData = arr

                      console.log('this.craftData', this.craftData)
                    } else {
                      this.craftData = [
                        {
                          ProgrammeName: '',
                          ProgrammeId: 0,
                          Processes: []
                        }
                      ]
                    }
                  })
              }

              if (this.currentStage === 1 || this.currentStage === 0) {
                this.craftData = []
              } else {
                this.craftData = [
                  {
                    ProgrammeName: '',
                    ProgrammeId: 0,
                    Processes: []
                  }
                ]
              }
            }
            console.log('this.craftData', this.craftData)

            // this.craftData = [
            //   { ProgrammeId: 0, ProgrammeName: "", Processes: [] },
            // ];
            // if (res.Data.ProcessModel) {
            //   if (res.Data.ProcessModel.length > 0) {
            //     this.craftData = [
            //       {
            //         ProgrammeId: res.Data.ProcessModel[0].ProgrammeId,
            //         ProgrammeName: res.Data.ProcessModel[0].ProgrammeName,
            //         Processes: res.Data.ProcessModel,
            //       },
            //     ];
            //   }
            // }
          }
        })
      }
    },
    changeQuantity(data, row, index) {
      if (row.T == null) row.T = 1
    },
    changeProgramme() {
      if (this.currentStage === 2 || this.currentStage === 3 || this.currentStage === 4) {
        this.$refs['listDialog' + this.currentStage].open()
      } else {
        this.$message.error('存货只有阶段为配件，装配，组装才有模具信息')
      }
    },
    changeProgrammeInfo(row) {
      this.$refs.processDialog.open().then(that => {
        that.setTableData(row)
      })
    },
    listDialogSelect(list) {
      let temps = JSON.parse(JSON.stringify(this.craftData))

      if (temps[0].Processes.length !== 0 && temps[0].Processes[0].T === 1) {
        temps[0].Processes.forEach(item => {
          item.T = 2
        })

        this.deleteCraftData.push(...temps)
      }
      console.log('list 方案', list)
      list.Processes.forEach(item => {
        item.ProcessType = null
        item.TradeUnitId = 0
        item.TradeUnitName = ''
      })
      this.craftData[0].ProgrammeId = list.ProgrammeId
      this.craftData[0].ProgrammeName = list.ProgrammeName
      this.craftData[0].Processes = list.Processes

      let copyCraftData = JSON.parse(JSON.stringify(this.craftData))
      this.craftData = []
      this.$nextTick(() => {
        this.craftData = copyCraftData
      })
    },
    detail_saved(list) {
      console.log('list', list)
      this.craftData[0].Processes = list
    },
    init() {
      this.pdApi
        .list({
          Status: 1,
          pageIndex: 1,
          pageSize: 7
        })
        .then(res => {
          let data = res.Data
          this.DAccount = data
          this.initDAccount = data
          this.listTotal = data.length
          this.initTotal = res.Count

          let data1 = res.Data
          this.child_DAccount = data1
          this.child_initDAccount = data1
          this.child_listTotal = data1.length
          this.child_initTotal = res.Count
        })
      this.propertyApi.list({ Status: 1 }).then(res => {
        if (res.Code === 0) {
          this.propertyList = res.Data
        }
      })

      this.tableData = [
        {
          ProductId: 0,
          ProductNo: '',
          ProductName: '',
          ProductSpec: '',
          UnitId: 0,
          UnitName: '',
          PdUnitId: 0,
          PdUnitName: '',
          Quantity: null,
          ImgUrl: '',
          ProcessStage: '',
          ProcessStageName: '',
          ProduceTypeName: '',
          BomNo: '',
          ProductionType: null,
          ProductNature: null,
          ProductionDpNo: '',
          ProductionDpId: null,
          IsDefault: false,
          Units: [],
          UseColor: true,
          ColorId: null,
          ColorName: '',
          Yieldrate: 100,
          PropertyId: null,
          PropertyName: '',
          DpId: null,
          TeImgs: []
        }
      ]
      this.child = [
        {
          ProductId: 0,
          ProductNo: '',
          ProductName: '',
          ProductSpec: '',
          UnitId: 0,
          UnitName: '',
          PdUnitId: 0,
          PdUnitName: '',
          Quantity: null,
          ImgUrl: '',
          ProcessStage: '',
          ProcessStageName: '',
          ProduceTypeName: '',
          ChildBomNo: '',
          Units: [],
          UseColor: true,
          ColorId: null,
          ColorName: '',
          Colors: [],
          Loss: 0,
          LossRate: 0,
          child_arrList: [],
          MouldBomNo: '',
          MouldBomNos: [],
          isSelectMouldBomno: false,
          isSelectMould: false,
          PropertyId: null,
          PropertyName: '',
          WarehouseId: null
        }
      ]
    },
    changeProductionDp(val, row) {
      let item = this.tradeUnitList.filter(v => {
        return v.TradeUnitId === val
      })[0]
      row.ProductionDpNo = item.TradeUnitNo
    },
    onSelectChild(e, row) {
      if (e.ProductId === this.tableData[0].ProductId && e.Bomno == this.tableData[0].BomNo) {
        row.ChildBomNo = ''
        row.ChildTeProductId = 0
        return this.$message.warning('子件bom不能添加父件bom')
      }
      if (row.T == null) row.T = 1
      row.ChildBomNo = e.Bomno
      row.ChildTeProductId = e.TeProductId
      console.log(row.BomNo, ' row.BomNo')
      row.ColorId = e.ColorId || null
      row.PropertyId = e.PropertyId || null
      row.PropertyName = e.PropertyName
      row.ColorName = e.ColorName
      if (e.BarCode) {
        row.BarCode = e.BarCode
      }
    },
    onSelectMouldBomNo(e, row) {
      row.MouldBomNo = e.Bomno
      if (row.T !== 0) {
        row.T = 1
      }
      row.isSelectMouldBomno = false
      console.log(e, 'onSelectMouldBomNo')
      if (e.BomRubbers) {
        var bomRubbers = e.BomRubbers.find(x => x.ProductId == row.ProductId)
        if (bomRubbers) {
          row.PropertyId = bomRubbers.PropertyId || null
          row.ColorId = bomRubbers.ColorId || null
          row.BarCode = bomRubbers.BarCode
          row.PropertyName = bomRubbers.PropertyName
          row.ColorName = bomRubbers.ColorName
        }
      } else {
      }
    },
    onSelect(e, row, type = 0) {
      // if(e.ProductId===this.tableData[0].ProductId){
      //   //this.$message.warning("子件不能添加父件");
      //   row.ProductName = "";
      // row.ProductId = 0;
      // row.ProductNo = "";
      // row.ProductSpec ="";
      // row.UseColor = false;
      // row.Colors = [];
      // row.ImgUrl = "";
      // row.ProcessStage = ""
      // row.ProduceTypeName = ""
      //   return false;
      // }else{
      console.log('e', e)
      row.UnitId = e.BaseUnitId
      row.UnitName = e.BaseUnitName
      row.PdUnitId = e.PdUnitId
      row.PdUnitName = e.PdUnitName
      row.Units = []
      row.Colors = e.Colors
      row.ColorId = null
      row.PropertyId = null
      row.ColorName = ''
      row.ProductName = e.ProductName
      row.ProductId = e.ProductId
      row.ProductNo = e.ProductNo
      row.ProductSpec = e.ProductSpec
      row.UseColor = e.UseColor
      row.Colors = e.Colors
      row.UseProcess = e.UseProcess
      row.LossRate = e.Loss || 0
      row.ProductType = e.ProductType
      row.ProductNature = e.ProductNature
      row.T = 0
      // if(e.Units.length === 0){
      //   row.UnitId = e.PdUnitId;
      //   row.UnitName = e.PdUnitName;
      // }else{
      //   row.Units = e.Units;
      // }
      // row.ImgUrl = e.ImgUrl;
      row.Imgs = e.Imgs
      row.ProcessStage = e.ProcessStage
      row.ProcessStageName = e.ProcessStageName
      row.ProduceTypeName = e.ProduceTypeName
      row.WarehouseId = e.DefaultWarehouse
      row.TrademarkNo = e.TrademarkNo
      if (e.IsPurchase == true && e.IsSale == false && e.IsMachining == false && e.IsExpend == false && e.IsLabourService == false) {
      } else {
        row.BarCode = e.ProductNo + '*0*0*0'
        if (row.TrademarkNo) {
          row.BarCode = e.ProductNo + '*0*0' + '*' + (row.TrademarkNo || 0)
        }
      }
      if (type === 0) {
        row.BomNo = e.ProductName
      }
      if (type === 0 && e.ProcessStage !== 0 && e.ProcessStage !== 1) {
        this.currentStage = e.ProcessStage

        if (e.HasProgramme) {
          console.log('触发', e.HasProgramme)
          this.teProgrammeApi
            .list({
              ProgrammeType: this.currentStage - 1,
              ProductName: row.ProductName,
              IsDefault: true
            })
            .then(res => {
              if (res.Code === 0) {
                let { ProgrammeId, ProgrammeName, Processes } = res.Data[0]
                Processes.forEach(item => {
                  item.ProcessType = null
                  item.TradeUnitId = 0
                  item.TradeUnitName = ''
                })
                let o = {
                  ProgrammeName,
                  ProgrammeId,
                  Processes
                }

                let arr = []
                arr.push(o)

                let temps = JSON.parse(JSON.stringify(this.craftData))
                if (temps[0].Processes.length !== 0 && temps[0].Processes[0].T === 1) {
                  temps[0].Processes.forEach(item => {
                    item.T = 2
                  })

                  this.deleteCraftData.push(...temps)
                }
                this.craftData = arr

                console.log('this.craftData', this.craftData)
              }
            })
        }
      }

      if (!e.HasProgramme && type === 0) {
        let temps = JSON.parse(JSON.stringify(this.craftData))
        if (temps.length > 0 && temps[0]?.Processes.length !== 0 && temps[0]?.Processes[0].T === 1) {
          temps[0].Processes.forEach(item => {
            item.T = 2
          })

          this.deleteCraftData.push(...temps)
        }
        if (e.ProcessStage === 0 || e.ProcessStage === 1) {
          this.craftData = []
        } else {
          this.craftData = [
            {
              ProgrammeName: '',
              ProgrammeId: 0,
              Processes: []
            }
          ]
        }
      }

      if (type == 1) {
        row.ChildBomNo = ''
        row.MouldBomNo = ''
        row.child_arrList = []
        row.MouldBomNos = []

        let data = {
          pageIndex: 1,
          pageSize: 10,
          ProductId: row.ProductId,
          Disabled: 0
        }
        this.api.list(data).then(res => {
          if (res.Code == 0) {
            row.child_arrList = res.Data
            console.log('row.child_arrList', row.child_arrList)
          }
        })
        row.isSelectChild = true
        row.isSelectMouldBomno = false
        row.isSelectMould = false
        if (e.IsPurchase == true && e.IsSale == false && e.IsMachining == false && e.IsExpend == false && e.IsLabourService == false) {
          row.isSelectChild = false
        }
        if (e.ProductType === 2 && e.MouldId != null) {
          row.isSelectMouldBomno = true
          row.isSelectMould = true
          let mouldId = e.MouldId

          row.MouldId = mouldId

          this.teMouldBomApi
            .bomList({
              IsEnable: true,
              mouldId
            })
            .then(res => {
              if (res.Code === 0) {
                row.MouldBomNos = res.Data
                console.log(row.MouldBomNos, 'onselect')
              }
            })
        }
      }
    },
    base64ToFile(dataurl, filename) {
      //将base64转换为文件
      var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, { type: mime })
    },
    async viewImg(row) {
      const res = await this.pdApi.productImgList(row.ProductId)
      if (res.Code != 0) return this.$message.warning(res.Msg)
      const ImgUrl = res.Data
      if (!ImgUrl || ImgUrl?.length < 1) return this.$message.warning('无图片！')
      let imgs = []
      ImgUrl.forEach(item => {
        // const imgBlob = URL.createObjectURL(this.base64ToFile(item.ImgUrl))
        // imgs.push(imgBlob)
        imgs.push('/api' + item.ImgUrl)
      })
      this.imgs = imgs
      this.$refs.imgDialog.open()
    },
    viewImg2(row) {
      console.log(row, 'img2')
      let imgs = []
      row.TeImgs.forEach(item => {
        imgs.push('/api' + item.ImgUrl)
      })

      this.imgs = imgs
      this.$refs.imgDialog.open()
    },
    resetChildFun() {
      this.child_pageParams.pageIndex = 1

      this.child_DAccount = this.child_initDAccount
      this.child_listTotal = this.child_initTotal
    },
    currentChildPage({ val, text1 }, row) {
      this.child_pageParams.pageIndex = val
      let o = {}
      if (this.currentClassChildId) {
        o = { pageIndex: val, pageSize: 7, Status: 1, IdChain: this.currentClassChildId, ProductName: text1 }
      } else {
        o = { pageIndex: val, pageSize: 7, Status: 1, ProductName: text1 }
      }
      this.pdApi.list(o).then(res => {
        if (res.Code == 0) {
          let data1 = res.Data
          this.child_DAccount = data1
          this.child_listTotal = res.Count
        }
      })
    },
    resetFun() {
      this.pageParams.pageIndex = 1
      this.DAccount = this.initDAccount
      this.listTotal = this.initTotal
    },
    currentPage({ val, text1 }, row) {
      this.pageParams.pageIndex = val
      let o = {}
      if (this.currentClassId) {
        o = { pageIndex: val, pageSize: 7, Status: 1, ClassId: this.currentClassId, ProductName: text1 }
      } else {
        o = { pageIndex: val, pageSize: 7, Status: 1, ProductName: text1 }
      }
      this.pdApi.list(o).then(res => {
        if (res.Code == 0) {
          this.DAccount = res.Data
          this.listTotal = res.Count
        }
      })
    },
    inputText(text, row) {
      if (text == row.ProductName) {
        return
      }
      row.ProductName = text

      let o = {}
      if (this.currentClassId) {
        o = {
          pageSize: this.pageParams.pageSize,
          pageIndex: this.pageParams.pageIndex,
          ProductName: text,
          ClassId: this.currentClassId,
          Status: 1
        }
      } else {
        o = {
          pageSize: this.pageParams.pageSize,
          pageIndex: this.pageParams.pageIndex,
          ProductName: text,
          Status: 1
        }
      }
      this.pdApi.list(o).then(res => {
        if (res.Code == 0) {
          this.DAccount = res.Data

          this.listTotal = res.Count
        }
      })
    },
    inputTextChild(text, row) {
      if (text == row.ProductName) {
        return
      }
      row.ProductName = text
      let o = {}
      if (this.currentClassChildId) {
        o = {
          pageSize: this.pageParams.pageSize,
          pageIndex: this.pageParams.pageIndex,
          ProductName: text,
          IdChain: this.currentClassChildId,
          Status: 1
        }
      } else {
        o = {
          pageSize: this.pageParams.pageSize,
          pageIndex: this.pageParams.pageIndex,
          ProductName: text,
          Status: 1
        }
      }
      this.pdApi.list(o).then(res => {
        if (res.Code == 0) {
          this.child_DAccount = res.Data
          this.child_listTotal = res.Count
        }
      })
    },
    delTableList(data, index) {
      // this.$message.success("删除");

      if (data.T !== 0) {
        data.T = 2
        this.deleteList.push(data)
      }

      this.child.splice(index, 1)
      if (this.child.length === 0) this.addList()
    },
    addColumn(row, column) {
      console.log(row.index)
      if (column.label === '操作') {
        return
      }
      if (row.index === this.child.length - 1) {
        this.addList()
      }
    },
    addList() {
      this.child.push({
        T: 0,
        ProductId: 0,
        ProductNo: '',
        ProductName: '',
        ProductSpec: '',
        UnitId: 0,
        UnitName: '',
        PdUnitId: 0,
        PdUnitName: '',
        Quantity: null,
        ImgUrl: '',
        ProcessStage: '',
        ProcessStageName: '',
        ProduceTypeName: '',
        ChildBomNo: '',
        MouldBomNo: '',
        MouldBomNos: [],
        child_arrList: [],
        isSelectMouldBomno: false,
        isSelectMould: false,
        Units: [],
        UseColor: true,
        ColorId: null,
        ColorName: '',
        PropertyId: null,
        PropertyName: '',
        Colors: [],
        LossRate: 0,
        WarehouseId: null
      })
    },
    newAdd() {},
    save() {
      if (this.isSaveProgramme && this.craftData[0].ProgrammeId !== 0) return this.$message.error('工艺方案变动，请重命名方案')

      if (this.isSaveProgramme) return this.$message.error('工艺方案变动，请先保存')

      let isNotProcessType = false
      this.craftData[0]?.Processes?.forEach(item => {
        if (item.ProcessType == null) {
          isNotProcessType = true
        }
      })

      if (isNotProcessType) {
        this.$message.error('请填写工序的生产类型')
        return
      }

      let data = this.tableData[0]

      // return this.$message.warning("数量不能为空并且不为0");
      if (data.BomNo == '') return this.$message.warning('bom版本号不能为空')
      if (data.ProductId == '') return this.$message.warning('请选择存货')
      if (data.Quantity == 0 || data.Quantity == null) return this.$message.warning('需求数量请输入大于0')

      data.BomType = 0
      data.TEBomId = 0
      data.ColorId = data.ColorId ?? 0
      data.PropertyId = data.PropertyId ?? 0

      let child = this.child.filter(item => item.ProductId > 0 && item.T !== null)
      let childLenght = child.length
      for (let i = 0; i < childLenght; ++i) {
        if (child[i].isSelectMouldBomno) {
          return this.$message.warning('请选择子件的注塑bom版本号')
        }
      }
      child = child.concat(this.deleteList)
      let check = child.filter(item => item.Quantity == 0 || item.Quantity == null)
      if (check.length > 0) {
        return this.$message.warning('需求数量请输入大于0')
      }
      if (child.length == 0 && data.TeProductId == 0) {
        return this.$message.warning('请选择子件')
      }
      data.Yieldrate = data.Yieldrate * 0.01
      child.forEach(item => {
        item.ColorId = item.ColorId ?? 0
        item.PropertyId = item.PropertyId ?? 0
      })
      data.DetailModels = child
      // let craftData = this.craftData.filter(
      //   (item) => item.ProgrammeId > 0 && item.T !== null
      // );
      // for (let i = 0; i < craftData.length; i++) {
      //   const item = craftData[i];
      //   item.Processes = item.Processes.filter((x) => x.Processes > 0);
      // }
      // console.log("craftData", craftData);
      // data.ProcessModels = craftData;

      let arr = []

      this.craftData[0]?.Processes?.forEach(item => {
        let o = {
          T: item.T ?? 0,
          ProgrammeId: item.ProgrammeId,
          ProcessType: item.ProcessType,
          DpId: item.DpId,
          TeProductProcessId: item.TeProductProcessId ?? 0,
          TeProductId: item.TeProductId ?? 0,
          ProcessId: item.ProcessId,
          ProcessSn: item.ProcessSn
        }
        arr.push(o)
      })

      this.deleteCraftData[0]?.Processes?.forEach(item => {
        let o = {
          T: 2,
          ProgrammeId: item.ProgrammeId,
          ProcessType: item.ProcessType,
          DpId: item.DpId ?? 0,
          TeProductProcessId: item.TeProductProcessId,
          TeProductId: item.TeProductId,
          ProcessId: item.ProcessId,
          ProcessSn: item.ProcessSn
        }
        arr.push(o)
      })

      data.ProcessModels = arr
      let teImgs = this.teImgs?.filter(item => item.T !== null)
      console.log(this.teImgs, teImgs, 'aa')
      data.TeImgs = teImgs
      //ProcessModels
      console.log('data', JSON.parse(JSON.stringify(data)))
      this.api
        .save2(data)
        .then(res => {
          if (res.Code == 0) {
            const id = res.Data
            this.$message({ type: 'success', message: res.Msg })
            this.deleteList = []
            //this.editOrder(data.TeProductId);
            if (this.selectId > 0) {
              this.loadInfo(this.selectId)
            } else {
              this.loadInfo(id)
            }
            this.$refs.type_tree.getData()
            this.isShow = false
          } else {
            this.$message({ type: 'warning', message: res.Msg })
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    saveAs() {
      // console.log(this.pickId,this.pId);
      this.$refs.bomDialog.open()
    },
    toSaveAs(data) {
      var loading = this.$loading({
        lock: true,
        text: '加载中...',
        spinner: 'el-icon-loading',
        customClass: 'my_loading',
        background: 'rgba(0, 0, 0, 0.3)'
      })
      this.api.saveAs({ TeProductDetailId: this.pId, TeProductId: this.pickId, Bomno: data.Bomno }).then(res => {
        loading.close()
        if (res.Code == 0) {
          this.$message.success(res.Msg)
          if (this.pId == 0) {
            this.onSelectTree({ TeProductId: res.Data })
          } else {
            this.onSelectTree({ TeProductId: this.data.TeProductId })
          }
          this.$refs.type_tree.getData()
          this.isShow = false
          this.close()
        } else {
          this.$message.error(res.Msg)
        }
      })
    },

    saveAsV2() {
      if (this.isSaveProgramme && this.craftData[0].ProgrammeId !== 0) return this.$message.error('工艺方案变动，请重命名方案')

      if (this.isSaveProgramme) return this.$message.error('工艺方案变动，请先保存')

      let isNotProcessType = false
      this.craftData[0]?.Processes?.forEach(item => {
        if (item.ProcessType == null) {
          isNotProcessType = true
        }
      })

      if (isNotProcessType) {
        this.$message.error('请填写工序的生产类型')
        return
      }

      let data = this.tableData[0]

      if (data.BomNo == '') return this.$message.warning('bom版本号不能为空')
      if (data.ProductId == '') return this.$message.warning('请选择存货')
      if (data.Quantity == 0 || data.Quantity == null) return this.$message.warning('需求数量请输入大于0')

      data.BomType = 0
      data.TEBomId = 0
      data.ColorId = data.ColorId ?? 0
      data.PropertyId = data.PropertyId ?? 0

      let child = this.child.filter(item => item.ProductId > 0)
      let childLenght = child.length
      for (let i = 0; i < childLenght; ++i) {
        if (child[i].isSelectMouldBomno) {
          return this.$message.warning('请选择子件的注塑bom版本号')
        }
      }
      // child = child.concat(this.deleteList);
      let check = child.filter(item => item.Quantity == 0 || item.Quantity == null)
      if (check.length > 0) {
        return this.$message.warning('需求数量请输入大于0')
      }
      if (child.length == 0 && data.TeProductId == 0) {
        return this.$message.warning('请选择子件')
      }
      data.Yieldrate = data.Yieldrate * 0.01
      child.forEach(item => {
        item.T = 0
        item.ColorId = item.ColorId ?? 0
        item.PropertyId = item.PropertyId ?? 0
      })
      data.DetailModels = child
      let arr = []

      this.craftData[0]?.Processes?.forEach(item => {
        let o = {
          T: 0,
          ProgrammeId: item.ProgrammeId,
          ProcessType: item.ProcessType,
          DpId: item.DpId,
          TeProductProcessId: item.TeProductProcessId ?? 0,
          TeProductId: item.TeProductId ?? 0,
          ProcessId: item.ProcessId,
          ProcessSn: item.ProcessSn
        }
        arr.push(o)
      })

      // this.deleteCraftData[0]?.Processes?.forEach((item) => {
      //   let o = {
      //     T: 2,
      //     ProgrammeId: item.ProgrammeId,
      //     ProcessType: item.ProcessType,
      //     DpId: item.DpId ?? 0,
      //     TeProductProcessId: item.TeProductProcessId,
      //     TeProductId: item.TeProductId,
      //     ProcessId: item.ProcessId,
      //     ProcessSn: item.ProcessSn,
      //   };
      //   arr.push(o);
      // });

      data.ProcessModels = arr
      console.log('data', JSON.parse(JSON.stringify(data)))
      var sub = { ...data, TeProductDetailId: this.pId || 0 }
      this.api
        .saveAsV2(sub)
        .then(res => {
          if (res.Code == 0) {
            // const id = res.Data;
            this.$message({ type: 'success', message: res.Msg })
            if (this.pId == 0) {
              this.onSelectTree({ TeProductId: res.Data })
            } else {
              this.onSelectTree({ TeProductId: this.selectId })
            }
            this.$refs.type_tree.getData()
            this.isShow = false
            this.close()
            this.deleteList = []
            // if (this.selectId > 0) {
            //   this.loadInfo(this.selectId);
            // } else {
            //   this.loadInfo(id);
            // }
          } else {
            this.$message({ type: 'warning', message: res.Msg })
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    tabClick() {},
    change(e, row) {
      if (row.T !== 0) {
        row.T = 1
      }
      this.$delete(row, 'WarehouseId')
      this.$set(row, 'WarehouseId', e)
    }
  }
}
</script>
<style>
.org-tree-node-label .org-tree-node-label-inner {
  padding: 0;
  border-radius: 0;
}
.labelcss {
  color: #ffffff;
  background-color: #1ba0e1;
  border-radius: 4px;
  min-height: 26px;
  padding: 0px 5px !important;
  line-height: 26px;
}
.labelcss .active {
  background-color: red;
}
.labelcss1 {
  background-color: #329b2f;
}
.labelcss2 {
  background-color: #f7883a;
}
.labelcss3 {
  background-color: #16dcdc;
}
.labelcss4 {
  background-color: #c0c0c0;
  color: #606266;
}
.node-select {
  box-shadow: 0 0 10px 1px #555555;
}

.flex {
  display: flex;
  justify-content: flex-end;
  margin: 6px 0;
}
.flex1 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 6px 0;
}
.flex2 {
  display: flex;
}
.mr8 {
  margin-right: 8px;
}
.option-span {
  display: inline-block;

  padding-right: 5px;

  width: 40%;
}
</style>
